import { AuditLogPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'

import SettingsCollectionsBootstrap from 'modules/audit_log/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import AuditTable from './_Table'

interface Props {
  streamId?: string
  streamModel?: string
}

const Container = observer(({ streamId, streamModel }: Props) => {
  const { data, loading, error } = useQuery(AuditLogPageDocument)
  const canSeeAuditLog = Boolean(data?.auditLog._policies.seeAuditLog)

  return (
    <ResponsivePage.Body authorized={canSeeAuditLog} loading={loading} error={error}>
      <AuditTable streamId={streamId} streamModel={streamModel} />
    </ResponsivePage.Body>
  )
})

const AuditLogPage = () => {
  return (
    <SettingsCollectionsBootstrap>
      <Container />
    </SettingsCollectionsBootstrap>
  )
}

export default AuditLogPage
